import { makeStyles } from '@material-ui/core/styles';

const dcsStyles = makeStyles((theme) => ({
  indexTextField: {
    // marginLeft: '8px',
    marginRight: '8px',
    width: 165,
  },
  selectInput: {
    marginRight: '16px',
    width: 165
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cellPadding: {
    padding: '16px'
  },
  textField: {
    marginLeft: '8px',
    marginRight: '8px',
    width: 165,
  },
  paper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  alert: {
    color: 'red'
  },
  pax: {
    borderBottom: 'solid gray 2px'
  },
  tableCellLessPad: {
    padding: '3px'
  }
}));

export default dcsStyles